import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../../assets/images/logo/remove_bac.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('home');
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".navbar-header");
      if (window.scrollY > 100) {
        header.style.background = "rgba(255, 255, 255, 0.98)";
        header.style.padding = "0.5rem 0";
      } else {
        header.style.background = "rgba(255, 255, 255, 0.95)";
        header.style.padding = "0.8rem 0";
      }

      // Only track sections if we're on the home page
      if (location.pathname === '/') {
        const sections = document.querySelectorAll('section');
        let currentSection = 'home';

        // Check if we're at the top of the page
        if (window.scrollY < 100) {
          currentSection = 'home';
        } else {
          sections.forEach(section => {
            const sectionTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;
            if (window.scrollY >= sectionTop - 150 && 
                window.scrollY < sectionTop + sectionHeight - 150) {
              currentSection = section.id;
            }
          });
        }
        setActiveLink(currentSection);
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    // Initial check
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  // Update active link when location changes
  useEffect(() => {
    if (location.pathname === '/') {
      // On home page, set to home initially
      setActiveLink('home');
      // Scroll to top when navigating to home
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // On other pages, set active link based on route
      setActiveLink(location.pathname.replace('/', '') || 'home');
    }
  }, [location.pathname]);

  const handleSectionClick = (sectionId) => {
    setActiveLink(sectionId);
    closeMenu();
    
    if (location.pathname !== '/') {
      // If we're not on home page, navigate to home first with hash
      window.location.href = `/#${sectionId}`;
    } else {
      // If we're already on home page, just scroll to section
      if (sectionId === 'home') {
        // Scroll to top for home
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } else {
        const element = document.getElementById(sectionId);
        if (element) {
          const offsetTop = element.offsetTop - 80;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      }
    }
  };

  const handlePageClick = (page) => {
    setActiveLink(page);
    closeMenu();
    
    // If clicking Home link and we're already on home page, scroll to top
    if (page === 'home' && location.pathname === '/') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  const isActive = (link) => {
    return activeLink === link ? 'navbar-active' : '';
  };

  return (
    <header className="navbar-header">
      <div className="navbar-container">
        <nav className="navbar-nav">
          <Link 
            to="/" 
            className="navbar-logo"
            onClick={() => {
              setActiveLink('home');
              closeMenu();
              // Scroll to top when clicking logo
              if (location.pathname === '/') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }}
          >
            <img
              src={logo}
              alt="ITY Logo"
              style={{ width: '65px', height: '56px', marginBottom: '-10px' }}
            />
          </Link>
          <ul className={`navbar-links ${isMenuOpen ? 'navbar-active' : ''}`}>
            <li className="navbar-item">
              <Link 
                to="/" 
                onClick={(e) => {
                  // Prevent default only if we're already on home page
                  if (location.pathname === '/') {
                    e.preventDefault();
                    handlePageClick('home');
                  } else {
                    handlePageClick('home');
                  }
                }}
                className={`navbar-link ${isActive('home')}`}
              >
                Home
              </Link>
            </li>
            <li className="navbar-item">
              <a 
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  handleSectionClick('about');
                }}
                className={`navbar-link ${isActive('about')}`}
              >
                About Us
              </a>
            </li>
            <li className="navbar-item">
              <a 
                href="#vision"
                onClick={(e) => {
                  e.preventDefault();
                  handleSectionClick('vision');
                }}
                className={`navbar-link ${isActive('vision')}`}
              >
                Vision & Mission
              </a>
            </li>
            <li className="navbar-item">
              <a 
                href="#objectives"
                onClick={(e) => {
                  e.preventDefault();
                  handleSectionClick('objectives');
                }}
                className={`navbar-link ${isActive('objectives')}`}
              >
                Objectives
              </a>
            </li>
            <li className="navbar-item">
              <a 
                href="#gallery"
                onClick={(e) => {
                  e.preventDefault();
                  handleSectionClick('gallery');
                }}
                className={`navbar-link ${isActive('gallery')}`}
              >
                Gallery
              </a>
            </li>
            <li className="navbar-item">
              <Link 
                to="/support" 
                onClick={() => handlePageClick('support')}
                className={`navbar-link ${isActive('support')}`}
              >
                Support Us
              </Link>
            </li>
            <li className="navbar-item">
              <Link 
                to="/events" 
                onClick={() => handlePageClick('events')}
                className={`navbar-link ${isActive('events')}`}
              >
                Events
              </Link>
            </li>
          </ul>
          <div className={`navbar-hamburger ${isMenuOpen ? 'navbar-active' : ''}`} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;